import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";
import SocialMediaLinks from "../ui/user/social-media-links";

export const ContactUs: FC = () => {
  const [state, dispatch] = useAppStateContext();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <h1>Contact Us</h1>
                  <p>
                    We're here to help! Reach out to us through any of the
                    following methods. We look forward to hearing from you and
                    we aim to respond to all inquiries in a timely manner.
                  </p>
                  <div className="pageMetadata">
                    <span className="pageMetadataLabel">Phone</span>
                    <span className="pageMetadataValue">
                      This service is not available currently.
                    </span>
                    <span className="pageMetadataLabel">Service email</span>
                    <span className="pageMetadataValue">
                      <a href="mailto:Support@digitalcharcoal.io">
                        Support@digitalcharcoal.io
                      </a>
                    </span>
                    <span className="pageMetadataLabel">General email</span>
                    <span className="pageMetadataValue">
                      <a href="mailto:Digicharcoal@gmail.com">
                        Digicharcoal@gmail.com
                      </a>
                    </span>
                    <span className="pageMetadataLabel">Follow us</span>
                    <span className="pageMetadataValue">
                      <SocialMediaLinks />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
